import React from 'react';
import Hammer from 'react-hammerjs';
import useStyles from './style';

// Render array of slides as PureComponent for performance optimization
// to ensure "renderSlides" is not called everytime the slide is panned
type RenderSlidesProps = {
  slides: unknown[];
  renderSlide: (key: number) => React.ReactNode;
};

class RenderSlides extends React.Component<RenderSlidesProps> {
  shouldComponentUpdate(nextProps: RenderSlidesProps) {
    return nextProps.renderSlide !== this.props.renderSlide;
  }

  render() {
    const { slides, renderSlide } = this.props;
    return slides.map((_, i) => {
      const key = i - 1;
      return renderSlide(key);
    });
  }
}

type SliderProps = {
  renderSlide: (key: number) => React.ReactNode;
  renderHeader?: () => React.ReactNode;

  slidesArray: unknown[];
  sliderRef: React.RefObject<HTMLDivElement>;
  handlePan: (e: HammerInput) => void;

  isPanEnabled: boolean;

  slideStyle: object;
};

const Slider = (props: SliderProps) => {
  const {
    renderSlide,
    renderHeader,

    slidesArray,
    sliderRef,
    handlePan,

    isPanEnabled,
    slideStyle,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.sliderWrapper}>
      {renderHeader && renderHeader()}
      <Hammer
        onPan={handlePan}
        options={{
          recognizers: {
            pan: { enable: isPanEnabled, threshold: 1 },
          },
        }}
      >
        <div className={classes.sliderInnerWrapper}>
          <div ref={sliderRef} className={classes.slider} style={slideStyle}>
            <RenderSlides
              slides={slidesArray}
              renderSlide={i => (
                <div key={i} className={classes.slide}>
                  {renderSlide(i)}
                </div>
              )}
            />
          </div>
        </div>
      </Hammer>
    </div>
  );
};

export default Slider;
